export function useIsDevelopment() {
  return process.env.NODE_ENV === 'development';
}
